export const LeadMagnetType = {
  LeadMagnetPDF: 'LeadMagnetPDF',
  LeadMagnetQuiz: 'LeadMagnetQuiz',
  LeadMagnetAudioVideo: 'LeadMagnetAudioVideo',
};
